"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VendorDocumentListResponse = exports.UpdateVendorDocumentInput = exports.CreateVendorDocumentInput = exports.VendorDocumentTransport = exports.DocumentTypeTransport = exports.VendorDocumentStatus = exports.VendorDocumentStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.VendorDocumentStatuses = ['CURRENT', 'EXPIRING', 'EXPIRED', 'SUPERSEDED'];
exports.VendorDocumentStatus = typebox_1.Type.Union(exports.VendorDocumentStatuses.map((v) => typebox_1.Type.Literal(v)));
/** Response schema for document_type records */
exports.DocumentTypeTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    name: typebox_1.Type.String(),
    code: typebox_1.Type.String(),
    description: typebox_1.Type.String(),
    required: typebox_1.Type.Boolean(),
    hasExpiration: typebox_1.Type.Boolean(),
    notApplicableOutside: typebox_1.Type.Optional(typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.Unknown())),
    sortOrder: typebox_1.Type.Number(),
    singleActive: typebox_1.Type.Boolean(),
    /** Whether documents of this type have lifecycle status tracking (CURRENT/EXPIRING/EXPIRED/SUPERSEDED). */
    hasStatus: typebox_1.Type.Boolean(),
    active: typebox_1.Type.Boolean(),
    metadata: common_1.MetaData,
});
/** Response schema for vendor_document records (includes signed S3 URL) */
exports.VendorDocumentTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    vendorId: typebox_1.Type.String({ format: 'uuid' }),
    orgId: typebox_1.Type.String({ format: 'uuid' }),
    documentTypeId: typebox_1.Type.String({ format: 'uuid' }),
    documentTypeCode: typebox_1.Type.String(),
    visibleToVendor: typebox_1.Type.Boolean(),
    fileUrl: typebox_1.Type.String(),
    fileName: typebox_1.Type.String(),
    checksum: typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()]),
    s3Ref: common_1.S3ItemReference,
    uploadedAt: typebox_1.Type.String({ format: 'date-time' }),
    expirationDate: typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()]),
    /** Null for document types where hasStatus is false (e.g. OTHER, PRICING_SHEET). */
    status: typebox_1.Type.Union([exports.VendorDocumentStatus, typebox_1.Type.Null()]),
    notes: typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()]),
    signedUrl: typebox_1.Type.Union([typebox_1.Type.String({ minLength: 1 }), typebox_1.Type.Null()]),
    metadata: common_1.MetaData,
    /** Only present when a duplicate was detected during creation (warn, don't block) */
    duplicate: typebox_1.Type.Optional(typebox_1.Type.Object({
        id: typebox_1.Type.String({ format: 'uuid' }),
        documentTypeCode: typebox_1.Type.String(),
        uploadedAt: typebox_1.Type.String({ format: 'date-time' }),
    })),
});
/** Request body for POST /v2/vendor-profiles/:profileId/documents */
exports.CreateVendorDocumentInput = typebox_1.Type.Object({
    documentTypeId: typebox_1.Type.String({ format: 'uuid' }),
    visibleToVendor: typebox_1.Type.Boolean(),
    s3Ref: common_1.S3ItemReference,
    checksum: typebox_1.Type.Optional(typebox_1.Type.String()),
    uploadedAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    expirationDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(exports.VendorDocumentStatus),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    fileName: typebox_1.Type.Optional(typebox_1.Type.String()),
});
/** Request body for PUT /v2/vendor-profiles/:profileId/documents/:docId */
exports.UpdateVendorDocumentInput = typebox_1.Type.Partial(typebox_1.Type.Object({
    documentTypeId: typebox_1.Type.String({ format: 'uuid' }),
    visibleToVendor: typebox_1.Type.Boolean(),
    expirationDate: typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()]),
    status: exports.VendorDocumentStatus,
    notes: typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Null()]),
}));
exports.VendorDocumentListResponse = typebox_1.Type.Object({
    results: typebox_1.Type.Array(exports.VendorDocumentTransport),
    total: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    thisBatch: typebox_1.Type.Number(),
});
//# sourceMappingURL=vendor-document-transport.js.map